var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#888B8D",
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M20.63 7.972c-.208-.771-.816-1.38-1.587-1.587C17.634 6 12 6 12 6s-5.634 0-7.043.37c-.756.208-1.379.83-1.586 1.602C3 9.38 3 12.3 3 12.3s0 2.935.37 4.328c.208.771.816 1.379 1.587 1.587C6.38 18.6 12 18.6 12 18.6s5.634 0 7.043-.37c.77-.208 1.379-.816 1.586-1.587.37-1.408.37-4.328.37-4.328s.016-2.935-.37-4.343zm-10.424 7.026V9.602L14.89 12.3l-4.685 2.698z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.b6f98a0b.svg";
export { ForwardRef as ReactComponent };